import { AppState } from '../../types'
import { builtInOrigin, BuiltInState } from './model'
import { environmentSelectorSelectors } from '../../common/environment/selectors'
import { resourceSelectorSelectors } from '../../common/resource/selectors'
import { versionSelectorSelectors } from '../../common/version/selectors'
import { IframeLoadingState } from '@mulesoft/monitoring-center-components'
import MonitoringLocalStorageManager, { BuiltInLocalStorage } from '../../util/storage/MonitoringLocalStorageManager'

export const selectors: any = {
  getAll: (state: AppState): BuiltInState => state.monitoring.builtIn,
  environmentSelector:
    environmentSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).environmentSelector),
  resourceSelector:
    resourceSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).resourceSelector),
  versionSelector:
    versionSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).versionSelector),
  landingPage: {
    environmentSelector:
      environmentSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).landingPage.environmentSelector),
    resourceSelector:
      resourceSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).landingPage.resourceSelector),
    versionSelector:
      versionSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).landingPage.versionSelector),
  },
  isLogPointsCompatible: (state: AppState) => {
    const appLogPointsEnabled = window.mc.featureFlags.logPoints.applications.enabled === 'true'
    const isResourceCompatibleWithLogPoints = selectors.getAll(state).isLogPointsCompatible
    return appLogPointsEnabled && isResourceCompatibleWithLogPoints
  },
  getResourceDetails: (state: AppState) => {
    const builtInData = MonitoringLocalStorageManager.get(builtInOrigin) as BuiltInLocalStorage
    const details = selectors.getAll(state).details
    return {...details, hidden: details.hidden === undefined ? builtInData.isDetailHidden : details.hidden}
  },
  isLoadingOrLoaded: (state: AppState) => {
    const isLoading = selectors.getAll(state).isLoading
    return  isLoading ===  IframeLoadingState.LOADING || isLoading ===  IframeLoadingState.LOADED
  },
  getDashboardType: () => {
    const builtInData = MonitoringLocalStorageManager.get(builtInOrigin) as BuiltInLocalStorage
    return (builtInData && builtInData.dashboardType) ? builtInData.dashboardType : ''
  },
  range: (state: AppState) => {
    const builtInData = MonitoringLocalStorageManager.get(builtInOrigin) as BuiltInLocalStorage
    return selectors.getAll(state).range ||  builtInData.range || {from: 'now-30m', to: 'now'}
  },
  autoRefresh: (state: AppState) => {
    const builtInData = MonitoringLocalStorageManager.get(builtInOrigin) as BuiltInLocalStorage
    const autoRefreshState = selectors.getAll(state).autoRefresh

    return {
      ...autoRefreshState,
      checked: autoRefreshState.checked === undefined ? builtInData.autoRefresh.checked : autoRefreshState.checked,
      frequency: autoRefreshState.frequency || builtInData.autoRefresh.frequency || undefined
    }
  }
}

export default selectors
